import React, { useState, useEffect, useRef } from 'react'
import { Modal, Slider, Button, Row, Col, Typography } from 'antd'
import VideoPlayer from './VideoPlayer' // Import the local wrapper which now supports volume
import { SoundOutlined, MutedOutlined } from '@ant-design/icons'

const { Text } = Typography

const ShotVolumeSettings = ({
  visible,
  onCancel,
  onSave,
  videoUrl,
  initialVolume = 25
}) => {
  const [volume, setVolume] = useState(initialVolume)

  // Reset volume when modal opens with new initialValue
  useEffect(() => {
    if (visible) {
      setVolume(initialVolume)
    }
  }, [visible, initialVolume])

  const handleSliderChange = value => {
    setVolume(value)
  }

  const handleSave = () => {
    onSave(volume)
  }

  return (
    <Modal
      title="Shot Volume Settings"
      visible={visible}
      centered
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Apply
        </Button>
      ]}
      width={600}
      destroyOnClose
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Video Preview */}
        <div
          style={{
            width: '100%',
            borderRadius: '8px',
            overflow: 'hidden',
            aspectRatio: '16/9' // Enforce aspect ratio instead of fixed height
          }}
        >
          {videoUrl ? (
            <VideoPlayer
              url={videoUrl}
              isVisible={true}
              volume={volume / 100} // Normalize to 0-1 for the player
              height="100%" // Ensure player fills the container
              showVolume={false}
            />
          ) : (
            <div
              style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff'
              }}
            >
              No Video Available
            </div>
          )}
        </div>

        {/* Volume Controls */}
        <div
          style={{
            padding: '16px',
            background: '#f5f5f5',
            borderRadius: '8px'
          }}
        >
          <Text strong style={{ marginBottom: '4px', display: 'block' }}>
            Adjust Volume ({volume}%)
          </Text>
          <Text
            type="secondary"
            style={{ fontSize: '12px', marginBottom: '16px', display: 'block' }}
          >
            This volume level will be applied to this shot when assembling the
            final video.
          </Text>
          <Row align="middle" gutter={16}>
            <Col flex="40px" style={{ textAlign: 'center' }}>
              {volume === 0 ? <MutedOutlined /> : <SoundOutlined />}
            </Col>
            <Col flex="auto">
              <Slider
                min={0}
                max={100}
                value={volume}
                onChange={handleSliderChange}
                marks={{
                  0: 'Mute',
                  25: '25%',
                  50: '50%',
                  75: '75%',
                  100: '100%'
                }}
              />
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
  )
}

export default ShotVolumeSettings
